import {
  EXTEND_FREE_LICENSE,
  EXTEND_FREE_LICENSE_SUCCESSFUL,
  EXTEND_FREE_LICENSE_FAILED,

  CLEAR_ALL_FREE_LICENSE_MESSAGES,
  CLEAR_ALL_FREE_LICENSE_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

export const extendFreeLicense = (extendLicenseData) => {
  console.log("freeLicense Actions :: ", extendLicenseData);
  return {
    type: EXTEND_FREE_LICENSE,
    payload: { extendLicenseData }
  };
};

export const extendFreeLicenseSuccessful = (extendLicenseSuccessData) => {
  console.log("freeLicense Actions :: ", extendLicenseSuccessData);
  return {
    type: EXTEND_FREE_LICENSE_SUCCESSFUL,
    payload: { extendLicenseSuccessData }
  };
};

export const extendFreeLicenseFailed = (extendLicenseFailureData) => {
  console.log("freeLicense Actions :: ", extendLicenseFailureData);
  return {
    type: EXTEND_FREE_LICENSE_FAILED,
    payload: { extendLicenseFailureData }
  };
};

export const clearAllFreeLicenseMessages = () => {
  return {
    type: CLEAR_ALL_FREE_LICENSE_MESSAGES,
    payload: { }
  };
};

export const clearAllFreeLicenseMessagesSuccessful = () => {
  return {
    type: CLEAR_ALL_FREE_LICENSE_MESSAGES_SUCCESSFUL,
    payload: { }
  };
};